window.addEventListener("load", function () {
    document.querySelectorAll('.popup_getlist2 .btn_get').forEach(function(btn) {
        
        if (btn.classList.contains('received')) {
            btn.textContent = btn.getAttribute('data-received');
        } else {
            btn.textContent = btn.getAttribute('data-default');
        }
        
    });
    // if ($("#popup_reward").hasClass("gift-1")) {
    //     console.log("aaaa");
    //     $("#popup_reward .bg-vongquay").attr("src","assets/libraryMainsite-t-popup/images/bg-login.png");
    // }
    // else {
    //     $("#popup_reward .bg-vongquay.MS__pc").attr("src","assets/libraryMainsite-t-popup/images/bg.png");
    //     $("#popup_reward .bg-vongquay.MS__mobile").attr("src","assets/libraryMainsite-t-popup/images/bg-mb.png");
    // }
});